export default __webpack_public_path__ + "resources/docs/1_recommendations_for success_ENG_compressed.c6bd19b5.pdf";